import type { Clause } from "../../../_services/RulesService";

/** Render a predicate as a human-readable sentence. */
export function predicateToString(clause: Clause | null | undefined): string {
  if (!clause) return "(no predicate)";
  if ("op" in clause) {
    if (clause.op === "and" || clause.op === "or") {
      if (clause.clauses.length === 0) return `(empty ${clause.op})`;
      const sep = clause.op === "and" ? " AND " : " OR ";
      return "(" + clause.clauses.map(predicateToString).join(sep) + ")";
    }
    if (clause.op === "not") {
      return "NOT " + predicateToString(clause.clause);
    }
  }
  switch (clause.type) {
    case "scope_completed":
      return `completed ${clause.scopeType} #${clause.scopeId}`;
    case "attendance_percent":
      return `attendance(${clause.scopeType} #${clause.scopeId}) ${clause.operator} ${clause.value}%`;
    case "test_score":
      return `test #${clause.testId} score ${clause.operator} ${clause.value}`;
    case "login_streak":
      return `login streak ≥ ${clause.minDays} days`;
    case "enrollment_age":
      return `enrolled ${clause.operator} ${clause.valueDays} days`;
    case "submission_count":
      return `submissions(${clause.scopeType} #${clause.scopeId}) ${clause.operator} ${clause.value}`;
    case "badge_held":
      return `holds badge #${clause.badgeDefinitionId}`;
    default:
      return `(unknown clause: ${JSON.stringify(clause)})`;
  }
}

interface Props {
  predicate: Clause | null | undefined;
  className?: string;
}

const RuleSummary: React.FC<Props> = ({ predicate, className }) => {
  return <code className={className}>{predicateToString(predicate)}</code>;
};

export default RuleSummary;
